import Nullstack from 'nullstack';
export default function IconDevices2({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-devices-2",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M10 15h-6a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h6"
  }), "   ", Nullstack.element("rect", {
    x: "13",
    y: "4",
    width: "8",
    height: "16",
    rx: "1"
  }), "   ", Nullstack.element("line", {
    x1: "7",
    y1: "19",
    x2: "10",
    y2: "19"
  }), "   ", Nullstack.element("line", {
    x1: "17",
    y1: "8",
    x2: "17",
    y2: "8.01"
  }), "   ", Nullstack.element("circle", {
    cx: "17",
    cy: "16",
    r: "1"
  }), "   ", Nullstack.element("line", {
    x1: "9",
    y1: "15",
    x2: "9",
    y2: "19"
  }), " ");
}